(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mobile-slider-moon-corn"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initOne(root) {
    if (!root || root.dataset.compareInit === '1') return;
    root.dataset.compareInit = '1';

    var track = root.querySelector('[data-compare-track]');
    var carousel = root.querySelector('[data-compare-carousel]') || root.querySelector('.carousel-container');
    var slides = root.querySelectorAll('[data-compare-track] > *');
    var nextBtn = root.querySelector('[data-compare-next]');
    if (!track || !carousel || !slides.length || !nextBtn) return;

    var current = 0;
    var total = slides.length;

    function update() {
      var width = carousel.clientWidth || carousel.getBoundingClientRect().width;
      if (!width) return;
      track.style.transform = 'translate3d(' + (-current * width) + 'px, 0, 0)';
    }

    var ignoreClick = false;
    function goNext() {
      current = (current + 1) % total;
      update();
    }

    nextBtn.addEventListener(
      'touchend',
      function (e) {
        e.preventDefault();
        ignoreClick = true;
        goNext();
      },
      { passive: false }
    );
    nextBtn.addEventListener('click', function (e) {
      if (ignoreClick) {
        ignoreClick = false;
        e.preventDefault();
        return;
      }
      e.preventDefault();
      goNext();
    });

    window.addEventListener('resize', update, { passive: true });
    window.addEventListener('load', update, { once: true });
    if (typeof requestAnimationFrame === 'function') requestAnimationFrame(update);
    else update();
  }

  function boot() {
    document.querySelectorAll('.corn-mobile[data-compare-slider]').forEach(initOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  // Shopify section JS can load after DOMContentLoaded
  setTimeout(boot, 0);
})();

  } catch(e) { console.error(e); }
})();
})();
